/**
 * 所有项目公共api列表
 * { requestName: '', api: '' }  example
 * requestName: 请求时使用的方法名
 * api: 请求接口
 */
export default [
  { requestName: 'queryData', api: 'https://randomuser.me/api' }, // 测试接口
  { requestName: 'login', api: '/login' }, // 登录
  { requestName: 'exit', api: '/exit' }, // 登录
  { requestName: 'sendLoginCode', api: '/sendLoginCode' }, // 登录获取验证码
  { requestName: 'codelogin', api: '/codelogin' }, // 验证码登录
  { requestName: 'frontmenu', api: '/frontmenu' }, // 获取用户菜单

  { requestName: 'user', api: '/user' }, // 人员管理
  { requestName: 'userIsExist', api: '/user/isExist' }, // 验证用户名是否存在
  { requestName: 'sendShortMsg', api: '/user/sendShortMsg' }, // 获取验证码
  { requestName: 'resetPassword', api: '/user/1/resetPassword' }, // 密码重置

  { requestName: 'role', api: '/role' }, // 角色管理
  { requestName: 'frontmenuAll', api: '/frontmenu/all' }, // 获取所有菜单

  { requestName: 'waterUserGetList', api: '/waterUser/getList' }, // PC端查询用水户列表
  { requestName: 'getIdAndNameList', api: '/waterUser/getIdAndNameList' }, // PC端查询用水户列表
  { requestName: 'waterUserById', api: '/waterUser/api' }, // PC端修改用水户
  { requestName: 'waterUserExportExcel', api: '/waterUser/exportExcel' }, // 用水户列表导出
  { requestName: 'waterUserHExportExcel', api: '/readMeter/3/exportExcel' }, // 用水户历史记录列表导出

  { requestName: 'readMeterGetList', api: '/readMeter/api/getList' }, // PC端查询抄表列表
  { requestName: 'getByWaterUserId', api: '/readMeter/api/1/getByWaterUserId' }, // PC端查询抄表列表
  { requestName: 'readMeter', api: '/readMeter' }, // PC端修改抄表列表
  { requestName: 'readMeterExportExcel', api: '/readMeter/exportExcel' }, // 抄表列表导出
  { requestName: 'readMeterPush', api: '/readMeter/push' }, // 抄表列表提交
  { requestName: 'pushByParam', api: '/readMeter/pushByParam' }, // 抄表列表提交

  { requestName: 'replaceMeterGetList', api: '/replaceMeter/api/getList' }, // PC端查询换表列表
  { requestName: 'replaceMeter', api: '/replaceMeter/1' }, // PC端修改换表列表
  { requestName: 'replaceMeterAudit', api: '/audit/1' }, // PC端修改换表列表
  { requestName: 'replaceMeterExportExcel', api: '/replaceMeter/exportExcel' }, // 换表列表导出
  { requestName: 'replaceMeterPush', api: '/replaceMeter/push' }, // 换表列表提交

  { requestName: 'tag', api: '/tag' }, // 标签管理
  { requestName: 'tagisExist', api: '/tag/isExist' }, //  验证标签是否存在
  { requestName: 'waterusenature', api: '/waterusenature' }, // 用水性质管理
  { requestName: 'waterusenatureisExist', api: '/waterusenature/isExist' }, // 验证用水性质是否存在

  { requestName: 'warningconfig', api: '/warningconfig' }, // 预警设置
  { requestName: 'warningrecord', api: '/warningrecord' }, // 预警记录
  { requestName: 'warningrecordExportExcel', api: '/warningrecord/export' }, // 预警记录导出

  { requestName: 'message', api: '/message/api/getList' }, // 消息列表
  { requestName: 'updateMessage', api: '/message' }, // 查看消息
  { requestName: 'deleteMessage', api: '/message' }, // 删除消息

  { requestName: 'auditRecord', api: '/auditRecord/api/getList' }, // 审核

  { requestName: 'changePassword', api: '/user/changePassword' }, // 修改密码
  { requestName: 'checkCode', api: '/user/checkCode' }, // 检查验证码

  { requestName: 'changeMobile', api: '/user/changeMobile' }, // 检查验证码

  { requestName: 'task', api: '/task' }, // 任务管理
  { requestName: 'taskGetListByLeader', api: '/task/getListByLeader' }, // 任务列表
  { requestName: 'getUnderling', api: '/user/getUnderling' }, // 查询当前领导下拥有的抄表员
  { requestName: 'getCorpDetail', api: '/corp' } // 查询当前领导下拥有的抄表员
]



// WEBPACK FOOTER //
// ./src/request/common.js